module.exports = __webpack_public_path__ + "static/img/IQ.6020ec2f.png";